export default __webpack_public_path__ + "static/media/burger_menu.81ba99ee.png";